import { Button } from 'aimo-ui';
import useCancelChargingMutation from 'hooks/useCancelChargingMutation';
import useOngoingChargingSession from 'hooks/useOngoingChargingSession';
import useParkingLinkedToCharging from 'hooks/useParkingLinkedToCharging';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { chargingAllowedToCancel } from 'utils/chargingUtils';
import ANPRChargingInfo from './terminate/ANPRChargingInfo';
import CancelParkingCharging from './terminate/CancelParkingCharging';
import CancelTermination from './terminate/ChargingStopCancel';

const CancelCharging: React.FC = () => {
  const { t } = useTranslation();
  const { ongoingChargingSession } = useOngoingChargingSession();
  const { parkingSession, allowStopOngoingParkingSession } =
    useParkingLinkedToCharging({
      parkingZoneUid: ongoingChargingSession?.parkingZoneUid,
    });

  const { cancelChargingSession, loading: cancelChargingLoading } =
    useCancelChargingMutation();

  const handleCancel = () => {
    cancelChargingSession({
      variables: {
        input: {
          chargingSessionId:
            ongoingChargingSession?.chargingSessionId as string,
        },
      },
    });
  };

  const cancelBoth = Boolean(
    allowStopOngoingParkingSession &&
      chargingAllowedToCancel(ongoingChargingSession?.status ?? 'IN_PROGRESS')
  );

  const renderContent = () => {
    if (cancelBoth) {
      return (
        <CancelParkingCharging
          cancelChargingLoading={cancelChargingLoading}
          cancelChargingSession={handleCancel}
          parkingSessionId={parkingSession?.sessionId ?? ''}
        />
      );
    }
    return (
      <StyledWrapper mb={20}>
        <Button
          size="l"
          testID="charging-cancel-confirm"
          buttonType="secondary"
          text={t('evCharging.cancelCharging')}
          onPress={() => handleCancel()}
          loading={cancelChargingLoading}
          disabled={cancelChargingLoading}
        />
      </StyledWrapper>
    );
  };

  return (
    <StyledWrapper mb={0}>
      <ANPRChargingInfo ongoingSession={parkingSession} />
      {renderContent()}
      <CancelTermination
        textKey={
          cancelBoth
            ? 'evCharging.continueChargingParking'
            : 'evCharging.continueCharging'
        }
        terminateBoth={cancelBoth}
      />
    </StyledWrapper>
  );
};
export default CancelCharging;
